//引入消息组件,因为使用频繁,所以注入减少创建销毁的开销
import messageDialogFile from '@/components/module/dialog/messageDialog.vue'
import loadingDialogFile from '@/components/module/dialog/loadingDialog.vue'
import agreeDialogFile from '@/components/module/dialog/agreeDialog.vue'
import eventAlarmDialogFile from '@/components/module/dialog/eventAlarmDialog.vue'
import audioControlFile from '@/components/module/universal/audioControl.vue'
import nomalInputDialogFile from '@/components/module/dialog/nomalInputDialog.vue'
import multipleSelectionDialogFile from '@/components/module/dialog/multipleSelectionDialog.vue'
import airConditioningDialogFile from '@/components/module/dialog/airConditioningDialog.vue'
import wulianAirConditioningDialogFile from '@/components/module/dialog/wulianAirConditioningDialog.vue'
import airConditioningPowerDialogFile from '@/components/module/dialog/airConditioningPowerDialog.vue'
import circleProgressDialogFile from '@/components/module/dialog/circleProgressDialog.vue'
import inprogressDialogFile from '@/components/module/dialog/inprogressDialog.vue'

export default {
	install(Vue, options) {
		function addDialog(dialogFile){
			var dialogClass = Vue.extend(dialogFile)
			var dialogBean = new dialogClass()
			document.body.appendChild(dialogBean.$mount().$el)
			return dialogBean
		}
		var messageDialog = addDialog(messageDialogFile)
		var loadingDialog = addDialog(loadingDialogFile)
		var agreeDialog = addDialog(agreeDialogFile)
		var eventAlarmDialog = addDialog(eventAlarmDialogFile)
		var audioControl = addDialog(audioControlFile)
		var multipleSelectionDialog = addDialog(multipleSelectionDialogFile)
		var airConditioningDialog = addDialog(airConditioningDialogFile)
		var wulianAirConditioningDialog = addDialog(wulianAirConditioningDialogFile)
		var airConditioningPowerDialog = addDialog(airConditioningPowerDialogFile)
		var circleProgressDialog = addDialog(circleProgressDialogFile)
		var inprogressDialog = addDialog(inprogressDialogFile)

		// 在Vue的原型上添加实例方法，以全局调用
		Vue.prototype.$dialogMethod = {
			createDialog(dialogFile) {
				var dialogClass = Vue.extend(dialogFile)
				var dialogVM = new dialogClass()
				document.body.appendChild(dialogVM.$mount().$el)
				return dialogVM
			},
			showMessage(msg) {
				messageDialog.showMessage(msg)
			},
			showLoading(urlName) {
				loadingDialog.showLoading(urlName)
			},
			closeLoading() {
				loadingDialog.closeLoading()
			},
			showInprogressDialog(time) {
				inprogressDialog.open(time)
			},
			closeInprogressDialog() {
				inprogressDialog.close()
			},
			openAgreeDialog(title, msg, callback, cancelcallback, showCance) {
				agreeDialog.open(title, msg, callback, cancelcallback, showCance)
			},
			openEventAlarm(dataList) {
				eventAlarmDialog.open(dataList)
			},
			closeEventAlarm() {
				eventAlarmDialog.close()
			},
			playWarn() {
				audioControl.playWarn()
			},
			pauseWarn() {
				audioControl.pauseWarn()
			},
			openSvgDialog(svgPath) {
				svgDialogControl.show(svgPath)
			},
			openNomalInputDialog(title, columns, callBack) {
				var nomalInputDialogClass = Vue.extend(nomalInputDialogFile)
				var nomalInputControl = new nomalInputDialogClass()
				document.body.appendChild(nomalInputControl.$mount().$el)
				nomalInputControl.open(title, columns, callBack)
			},
			getMultipleSelectionDialog() {
				return multipleSelectionDialog
			},
			openMultipleSelectionDialog(title, dataList, defaultCheckedIds, callback, cancelCallback) {
				multipleSelectionDialog.openMultipleSelectionDialog(title, dataList, defaultCheckedIds, callback, cancelCallback)
			},
			openSingleItemDialog(title, dataList, defaultCheckedId, callback, cancelCallback) {
				multipleSelectionDialog.openSingleItemDialog(title, dataList, defaultCheckedId, callback, cancelCallback)
			},
			openSingleGroupDialog(title, dataList, defaultCheckedId, callback, cancelCallback) {
				multipleSelectionDialog.openSingleGroupDialog(title, dataList, defaultCheckedId, callback, cancelCallback)
			},
			openAirConditioningDialog(group, operation, timeout, prop,callback,cancelCallback,showCance) {
				airConditioningDialog.open(group, operation, timeout, prop,callback,cancelCallback,showCance)
			},
			openWulianAirConditioningDialog(group, operation, timeout, prop,callback,cancelCallback,showCance) {
				wulianAirConditioningDialog.open(group, operation, timeout, prop,callback,cancelCallback,showCance)
			},
			openAirConditioningPowerDialog(group, operation, timeout, prop,callback,cancelCallback,showCance) {
				airConditioningPowerDialog.open(group, operation, timeout, prop,callback,cancelCallback,showCance)
			},
			openCircleProgressDialog(title,nowRate){
				circleProgressDialog.open(title,nowRate)
			},
			closeCircleProgressDialog(){
				circleProgressDialog.close()
			},
		}
	}
}
